/** Grouped digits, always en-US so a figure reads the same everywhere (4231 becomes "4,231"). */
export function fmtNum(n: number): string {
  return n.toLocaleString("en-US");
}

const TIERS: ReadonlyArray<readonly [number, string]> = [
  [1_000_000_000, "B"],
  [1_000_000, "M"],
  [1_000, "k"],
];

/**
 * A short figure for a large count: exact up to 9,999, then 10.2k, 1.4M, 2.3B
 * with one decimal dropped when it is zero. Always pair it with
 * `title={fmtNum(n)}` so the exact figure is on hover. Never use it for a
 * pager range, which is always exact.
 */
export function abbreviateCount(n: number): string {
  if (n <= 9_999) return fmtNum(n);
  // The threshold of the tier above the one being tried.
  let above: number | undefined;
  for (const [threshold, suffix] of TIERS) {
    if (n < threshold) {
      above = threshold;
      continue;
    }
    const scaled = Math.round((n / threshold) * 10) / 10;
    // 999,950 rounds to 1000k: promote it to the tier above instead.
    if (scaled >= 1000 && above !== undefined) return abbreviateCount(above);
    return `${scaled % 1 === 0 ? scaled.toFixed(0) : scaled.toFixed(1)}${suffix}`;
  }
  return fmtNum(n);
}

/** "1 item", "3 items", "1,153 items": the count with its noun in the right number. */
export function countLabel(n: number, singular: string, plural = `${singular}s`): string {
  return `${fmtNum(n)} ${n === 1 ? singular : plural}`;
}
